// import $ from 'jquery';

type TLink = {
	$label_linker: {
		[field_name: string]: {
			label_id?: string;
			input_id?: string;
		};
	};
};

export namespace LabelInputLinker {
	function getLink(scope: any, field_name: string) {
		const link = scope as TLink;
		if (!link.$label_linker) {
			link.$label_linker = {};
		}
		if (!link.$label_linker[field_name]) {
			link.$label_linker[field_name] = {};
		}
		return link.$label_linker[field_name];
	}

	function linkLabelAndInput(label_id: string | undefined, input_id: string | undefined) {
		if (!label_id || !input_id) {
			return;
		}
		//link
		const $label:HTMLLabelElement | null = document.getElementById(label_id) as any;// $('#' + label_id);
		if($label){
			$label.setAttribute('for', input_id);
		}
		// $label.attr('for', input_id);
	}

	export function addLabel(scope: any, field_name: string, ele_id: string) {
		const link = getLink(scope, field_name);
		link.label_id = ele_id;
		linkLabelAndInput(link.label_id, link.input_id);
	}

	export function addInput(scope: any, field_name: string, ele_id: string) {
		const link = getLink(scope, field_name);
		link.input_id = ele_id;
		linkLabelAndInput(link.label_id, link.input_id);
	}
}
